import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from '../utils/cn';
/** MUI-`Stack`-Ersatz: Flex-Layout mit token-naher `spacing`-Skala (8px-Raster). */
export const Stack = forwardRef(function Stack({ direction = 'column', spacing = 0, align, justify, wrap, style, className, ...rest }, ref) {
    const layout = {
        display: 'flex',
        flexDirection: direction,
        gap: spacing ? `${spacing * 8}px` : undefined,
        alignItems: align,
        justifyContent: justify,
        flexWrap: wrap ? 'wrap' : undefined,
        ...style,
    };
    return _jsx("div", { ref: ref, className: cn(className), style: layout, ...rest });
});
